
define('eteration/widgets/ui-recaptcha-enterprise',[ 'jquery', 'knockout', 'eteration/eteration-ajax', 'ui-helper/storage-helper'],

	function($, ko, etrAjax, storageHelper, moment, humanize, i18n) {
		var publicKey = '6LeSMSIqAAAAAP9RxtQIkvaGmFGYWuR4elfglTqM';
		var domain = "https://www.google.com/recaptcha/enterprise.js";
		var countryCodeField = "cd_GeoCountry";
		var countryCode = storageHelper.getItem({ key: countryCodeField, webStorageType: storageHelper.Stores.SESSION_STORAGE });
		var isCaptchaBlocked = null;
		var TEMP_TOKEN = 'TEMP_TOKEN';

		function MyPromise(executor) {
			this.thenCallbacks = [];
			this.isResolved = false;
			this.value = null;

			var that = this;
			executor(function(val) {
				if (!that.isResolved) {
					that.isResolved = true;
					that.value = val;
					that.thenCallbacks.forEach(function(cb) {
						cb(val);
					});
				}
			});
		}

		MyPromise.prototype.then = function(cb) {
			if (this.isResolved) {
				cb(this.value);
			} else {
				this.thenCallbacks.push(cb);
			}
			return this; // added to support promise chaining
		};

		if (!countryCode) {
			etrAjax.get({
				app: 'app.common',
				service: '/parameters/clientinfo',
				disableLoader: true,
				disableErrorHandling: true,
				callback: function (response) {
					if (response && response.data && response.data[countryCodeField] === "CN") {
						storageHelper.setItem({
							key: countryCodeField,
							value: response.data[countryCodeField],
							webStorageType: storageHelper.Stores.SESSION_STORAGE
						});
						isCaptchaBlocked = true;
					} else {
						isCaptchaBlocked = false;
					}
				},
				error: function() {
					isCaptchaBlocked = false;
				}
			});
		} else if (countryCode === "CN") {
			isCaptchaBlocked = true;
		}

		ko.bindingHandlers.captchaEnterprise = {
			addRecaptchaToScript: function () {
				setTimeout(function () {
					if (isCaptchaBlocked) { return; }
					$.getScript(domain + '?render=' + publicKey);
				}, 1000)
			},

			addRecaptchaTerms: function (submitButtonId, beforeTheButton) {
					if (isCaptchaBlocked) { return; }

					var terms = "<div class='row p-10 text-start'><div class='col-lg-12'>" +
						"This site is protected by reCAPTCHA and the Google " +
						"<a class='txt-black' href='https://policies.google.com/privacy'>Privacy Policy</a> and " +
						"<a class='txt-black' href='https://policies.google.com/terms'>Terms of Service</a> apply" +
						"</div></div>";
					var btnRow = document.getElementById(submitButtonId).closest('.row');

					if (btnRow) { btnRow.insertAdjacentHTML(beforeTheButton ? 'beforebegin' : 'afterend', terms); }
			},

			validateCaptcha: function (pageName) {

					if(isCaptchaBlocked) {
						var promise = new MyPromise(function(resolve) {
							setTimeout(function() {
								resolve(TEMP_TOKEN);
							}, 1000);
						});

						return promise.then(function(result) {
							return result;
						});
					} else {
						return grecaptcha.enterprise.execute(publicKey, {action: pageName}).then(function(token){
							return token;
						});
					}

			},

			resetCaptcha: function () {
					if (isCaptchaBlocked) { return; }

					if (window.grecaptcha && grecaptcha.enterprise) {
						grecaptcha.enterprise.reset();
					}
			}
		};
	});